var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.995 480C399.667 480 399.354 480 399.011 480C378.48 479.562 360.481 466.126 354.263 446.565L288 238.329L221.737 446.565C215.519 466.126 197.52 479.562 176.989 480C155.772 480.031 137.913 467.688 130.898 448.408L2.904 96.432C-6.158 71.528 6.7 43.967 31.605 34.905C56.479 25.843 84.056 38.686 93.118 63.622L172.974 283.232L242.268 65.466C248.596 45.561 267.095 32.03 288 32.03S327.404 45.561 333.732 65.466L403.026 283.232L482.882 63.622C491.944 38.686 519.427 25.843 544.395 34.905C569.3 43.967 582.158 71.528 573.096 96.432L445.102 448.408C438.196 467.407 420.15 480 399.995 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.4e284762f1cfc0af978502fcc97b62f3.svg";
export { ForwardRef as ReactComponent };